"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeSessionCreatePayloadSchema = exports.RealtimeSessionObjectSchema = exports.RealtimeSessionActionSchema = exports.RealtimeSessionTypeEnumSchema = void 0;
const zod_1 = require("zod");
// Common
exports.RealtimeSessionTypeEnumSchema = zod_1.z
    .enum(['realtime'])
    .openapi('RealtimeSessionType');
// Object
exports.RealtimeSessionActionSchema = zod_1.z
    .object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    schema: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
})
    .openapi('RealtimeSessionAction');
exports.RealtimeSessionObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('realtime_session'),
    type: exports.RealtimeSessionTypeEnumSchema,
    client_secret: zod_1.z.string(),
    // schema: z.record(z.string(), z.any()).nullable(),
    actions: zod_1.z.array(exports.RealtimeSessionActionSchema),
    expires_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
    created_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('RealtimeSessionObject');
// Create
exports.RealtimeSessionCreatePayloadSchema = zod_1.z
    .object({
    thread: zod_1.z.string(),
    type: exports.RealtimeSessionTypeEnumSchema,
    modalities: zod_1.z.array(zod_1.z.enum(['audio', 'text'])).optional(),
    tools: zod_1.z
        .array(zod_1.z
        .object({
        description: zod_1.z.string().optional(),
        name: zod_1.z.string(),
        type: zod_1.z.literal('function'),
        parameters: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    })
        .openapi('RealtimeSessionCreateToolPayload'))
        .optional(),
})
    .openapi('RealtimeSessionCreatePayload');
//# sourceMappingURL=realtimeSessionSchema.js.map